import * as React from "react";
const SvgTextRedo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 1080, height: 1080, viewBox: "0 0 1080 1080", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("desc", null, "Created with Fabric.js 5.2.4"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1 0 0 1 540 540)", id: "2729b6c0-07c6-4a7b-b180-eadce1c7424a" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(255,255,255)",
  fillRule: "nonzero",
  opacity: 1,
  visibility: "hidden"
}, vectorEffect: "non-scaling-stroke", x: -540, y: -540, rx: 0, ry: 0, width: 1080, height: 1080 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1 0 0 1 540 540)", id: "20a27f8d-e329-4723-8506-5a6d18924b3d" }), /* @__PURE__ */ React.createElement("g", { transform: "matrix(33.75 0 0 33.75 540 540)" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(0,0,0)",
  fillRule: "nonzero",
  opacity: 1
}, transform: " translate(-18.7, -16)", d: "M 25.5733 13.8823 L 17.1811 13.8823 C 13.019 13.8823 10.5786 15.8092 9.88835 18.8723 C 9.28483 21.5503 10.2765 24.4534 11.9306 25.3731 C 12.6447 25.7701 12.8811 26.636 12.4585 27.307 C 12.0358 27.978 11.1143 28.2001 10.4001 27.803 C 7.51465 26.1986 6.09929 22.0552 6.94841 18.2874 C 7.92828 13.9394 11.5763 11.0588 17.1811 11.0588 L 25.5733 11.0588 L 20.6255 6.41001 C 20.0387 5.85869 20.0387 4.96482 20.6255 4.41349 C 21.2123 3.86217 22.1637 3.86217 22.7505 4.41349 L 30.2352 11.4459 C 30.524 11.7032 30.7041 12.0671 30.7041 12.4705 C 30.7041 12.8739 30.524 13.2378 30.2352 13.4951 L 22.7505 20.5275 C 22.1637 21.0788 21.2123 21.0788 20.6255 20.5275 C 20.0387 19.9762 20.0387 19.0823 20.6255 18.531 L 25.5733 13.8823 Z", strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1.56 0 0 1.91 451.48 724.06)", style: {}, id: "08a3d627-f786-44f9-a513-0d1d50870cc5" }, /* @__PURE__ */ React.createElement("text", { xmlSpace: "preserve", fontFamily: "Raleway", fontSize: 200, fontStyle: "normal", fontWeight: 900, style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(0,0,0)",
  fillRule: "nonzero",
  opacity: 1,
  whiteSpace: "pre"
} }, /* @__PURE__ */ React.createElement("tspan", { x: -62.4, y: 62.83 }, "T"))));
export default SvgTextRedo;
